import { render, staticRenderFns } from "./generatePayrollReportsPopUp.vue?vue&type=template&id=45c4c9d8&scoped=true"
import script from "./generatePayrollReportsPopUp.vue?vue&type=script&lang=js"
export * from "./generatePayrollReportsPopUp.vue?vue&type=script&lang=js"
import style0 from "./generatePayrollReportsPopUp.vue?vue&type=style&index=0&id=45c4c9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4c9d8",
  null
  
)

export default component.exports